import axios from 'axios'
import { Toast } from 'vant'
import qs from 'qs'
import { getCookie } from '@/utils/tool';
// 创建axios实例
const service = axios.create({
  baseURL: window.location.origin, // api 的 base_url
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
  timeout: 50000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(
  config => {
    // 请求为post,且要求请求数据为key/value格式
    if (config.data === undefined) {
      config.data = ''
    }
    if (config.method === 'post' && config.headers && config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('application/x-www-form-urlencoded') !== -1) {
      config.transformRequest = [function(data) {
        return qs.stringify(data);
      }]
    }
    if (localStorage.getItem('token')) {
      config.headers['usertoken'] = localStorage.getItem('token');
    }
    if (getCookie('CUSTOM-TAL-TOKEN')) {
      config.headers['usertoken'] = getCookie('CUSTOM-TAL-TOKEN');
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.code !== 20000 && res.statusCode !== 200) {
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014 || res.statusCode === 401) {
        // 针对获取用户id的接口不弹出toast
        if (response.config.url.indexOf('user/info') === -1) {
          Toast({
            message: '被登出',
            className: 'px-vant-toast'
          });
        }
      }
      return response.data
    } else {
      return response.data
    }
  },
  error => {
    console.log('request.js response error', error)
    return Promise.reject(error)
  }
)

export default service
